import React from 'react';
import { Switch, Route } from 'react-router-dom';
import {
  HOTEL_BOOKING,
  HOTEL_DETAIL,
  HOTELS_SEARCH,
  PAYMENTS_HOTELS,
  ASSIST_SEARCH,
  ASSIST_BUY,
  ASSIST_PAYMENTS,
  ASSIST_PAYMENTS_SUCCESSFUL,
  LOTTERY,
  BOOKING_DETAIL,
  CONTACT_US,
  PAYMENT_METHODS,
} from '@shared/helpers/routes';

import AssistSearchPage from '@shared/pages/AssistCard/AssistCardSearchPage';
import AssistCardReservePage from '@shared/pages/AssistCard/AssistReserve';
import AssistPayments from '@shared/pages/AssistCard/AssistPayments';
import AssistPaymentsDone from '@shared/pages/AssistCard/AssistPaymentsDone';
import HotelSearchPage from '@shared/pages/Hotels/HotelSearch';
import HotelDetailsPage from '@shared/pages/Hotels/HotelDetail';
import HotelBookingPage from '@shared/pages/Hotels/HotelBooking';
import HotelsPayments from '@shared/pages/Hotels/HotelsPayments';
import MyBookingPage from '@shared/pages/MyBookingPage';
import Lottery from '@shared/pages/Lottery';
import ContactUs from '@shared/pages/ContactUs';
import RouterStarlings from './RouterFlights';
import PaymentMethods from '@shared/pages/PaymentMethods';

export default ({ site_functions }) => {
  return (
    <Switch>
      {site_functions.showContact && (
        <Route exact path={CONTACT_US}>
          <ContactUs />
        </Route>
      )}

      {site_functions.showPaymentMethods && (
        <Route exact path={PAYMENT_METHODS}>
          <PaymentMethods />
        </Route>
      )}

      <Route path={LOTTERY}>
        <Lottery />
      </Route>

      <Route exact path={HOTELS_SEARCH}>
        <HotelSearchPage />
      </Route>

      <Route exact path={HOTEL_DETAIL}>
        <HotelDetailsPage />
      </Route>

      <Route exact path={HOTEL_BOOKING}>
        <HotelBookingPage />
      </Route>

      <Route exact path={PAYMENTS_HOTELS}>
        <HotelsPayments />
      </Route>

      <Route exact path={BOOKING_DETAIL}>
        <MyBookingPage />
      </Route>

      <Route exact path={ASSIST_SEARCH}>
        <AssistSearchPage />
      </Route>

      <Route exact path={ASSIST_BUY}>
        <AssistCardReservePage />
      </Route>

      <Route exact path={ASSIST_PAYMENTS}>
        <AssistPayments />
      </Route>

      <Route exact path={ASSIST_PAYMENTS_SUCCESSFUL}>
        <AssistPaymentsDone />
      </Route>

      <RouterStarlings />
    </Switch>
  );
};
